import React from 'react';
import $ from 'jquery';
import NavMenu from '../../components/navMenu/navMenu.jsx';
import HeaderMenu from '../../components/headerMenu/headerMenu.jsx';
import '../../assets/css/common.less';
import MyLoading from '../../components/showLoading/showLoading.jsx';
import ShowWarn from '../../components/showWarn/showWarn.jsx';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog,Upload,MessageBox } from 'element-react';
import { requests, getToken, loadZhuKeToken,getLoginShopInfo,messageShow,isNotNull,systemConfig,getZkShopName,getTaoteShopName } from '../../utils/http.js';
import ShowModal from '../../components/showModal/index.jsx';
import SelectCategoryModule from '../../components/selectCategoryModule/index.jsx';
import PlatformName from '../../components/platformName/index.jsx';
import { ImageSearchProductRequest,BatchListingMobileByProductIdListV2Request } from '../../utils/api.js';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import { huoyuanLink } from '../../utils/index'
import TableNavChange from '../../components/tableNavChange/tableNavChange.jsx';
import PreviewDistributionList from '../../components/previewDistributionList/index.jsx';
import './alibabaRecommendProduct.less'
import { otherExposureReport } from '../../utils/alibabareport.js';

class AlibabaRecommendProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alibabaPageKey:'1688_yjdf',
            shopList: [],
            openUrl: "https://s.1688.com/erpoffer/offer_search.html?keywords=&charset=utf8&erp_app_key=8076003",
            findValue: 'goods',
            isPifatuanProduct: true,
            isLoading: false,
            hasLoadBorder: false,//加载，背景框
            loadingTitle: "加载中...",
            tabList:[
                { id: 1, value: "AlibabaZhuKe", title: "1688", active: true},
                // { id: 2, value: "TaoteZhuKe", title: "淘特", active: true},
            ],

            //分页 
            pagesize: 20,
            totals: 0,
            current: 1,

            categoryList: [],//类目列表
            tagList: [],//标签列表

            productList: [],//精选列表
            selectProductNumber: 0,//选中的数量

            orderby: "",
            sort: "0",

            isShowPuHuo: false,

            taskCodeRes: { taskCode: '', isPost: false, allNumber: 0, successNumber: 0, errorNumber: 0, errorList: [] },//铺货后，返回的任务code
            isShowTaskCodeRes: false,

            //====================铺货前，显示商品和类目匹配 ============================
            isShowByDistributionSelectCategory: false,
            supplierProductListByBatch: [],//铺货前，获取商品列表
            affirmByeBatchDistributionByData: {},

            selectCategoryByProductId: '',//选择类目的商品Id
            selectCategoryByShopId: 0,//选择类目的店铺Id
            selectCategoryByPlatform: '',//选择类目的平台
            selectCategoryValueList: [],
            //isNotSelectCateforyNumber: 0,//没有选择类目
            isShowOverlookByCategorySelect: false,
            //====================铺货前，显示商品和类目匹配 end============================


            versionsDistinction: [],//版本金额等区别
            functionDistinction: [],//版本功能区分
            payUserList: [],//订购用户滚动数据
            PayInfoList: [],//优惠券数组
            PayIndex: 1,//套餐类型
            upgradeUrl: '',//升级链接
            lingQuUpgradeUrl: '',// 领劵升级

            isShowAddShopByUpgradeApp: false,//免费版，超过5个的弹窗
            isShowChoosePlatform: false,  //显示添加平台弹窗
            isShowAuthShop: false,//是否完成授权弹窗
            selectPlatform: 'TouTiao',


            isShowReachListingCount: false,
            changeSearchNav: '找货源',
            isShowFiltbarMoreOperate: false,
            sortNav: [
                { Title: "", Name: "综合", IsSelect: true, isIcon: false },
                { Title: "salesCnt", Name: "销量", IsSelect: false, isIcon: true,childSort:true },
                { Title: "minPrice", Name: "价格", IsSelect: false, isIcon: true,childSort:true },
            ],

            /**=========================当前登录店铺信息==================================== */
            selectShopId:undefined,//店铺id
            selectShopName:undefined,//店铺名
            selectplatformType:undefined,//对应平台

            /**=========================图片dto ====================== */
            imageUrl:"",
            selectSourcePlatform:'AlibabaZhuKe',
            imageFileList:[],//
            supplierProductList: [],//精选列表
            listingProductList:[],//准备铺货商品

            ciphertextOrderSetDailog:false,
            showPreviewDistributionDailog:false,
            selectPreviewProductList:[]  //预览铺货商品表
            
        };
    }

    componentDidMount(props) { //组件挂载到DOM渲染后被执行，只会执行一次。
        //this.loadShopList();
       
        
        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
        {
            that.loadData();
            that.loadList();
        }
        else {
            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    //var hasZhukeLoginShopTokens = "";//测试。
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);

                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData();
                            else
                                that.setState({ isShowWarn: true });

                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else{
                    that.loadData();
                }
            }, 500);
        }
        $(function(){
            $(window).off('message')
            $(window).on('message',(event)=>{
                that.listener_1688JxhySearch(event && event.originalEvent);
               
            })
        })
    }
    listener_1688JxhySearch(event){
        const { data: eventData } = event;
        console.log(' this.props.location.pathname=>', this.props.location.pathname);
        console.log(eventData);
        if (event && eventData && eventData.type === '1688_jxhy_search' && this.props.location.pathname.includes("alibabaRecommendProduct")) 
        {
            console.log(eventData);
            var ids=eventData.data['1688_item_id'];
            if(ids)
            {
                var arr= ids.split(',');
                var arrData=[];
                arr.forEach(element => {
                  arrData.push({ProductId:element})
                });
                if (this.checkSourcePlatformAuthDailog()) {
                    this.setState({
                        listingProductList: arrData,
                        isShowPuHuo: true
                    });
                }
            }
        }
    }


    loadData = () => {
        var shopInfo = getLoginShopInfo();
        var that = this;
        this.state.shopList = [{
            Id:shopInfo.loginShopId,
            ShopName:shopInfo.loginShopName,
            PlatformType:shopInfo.loginShopPlatformType,
            IsChecked:true,
            AuthUrl:'',
            PayUrl:''
        }];
        otherExposureReport(that.state.alibabaPageKey);
    }

    findButton = (types) => {
        var findValue = this.state.findValue;
        var changeSearchNav = types == "goods" ? "找货源" : types == "factory" ? "找工厂" : "";
        this.setState({ changeSearchNav })
        if (findValue == types)
            return;

        $("#zhukeOfferSearchInputId").val("");

        var openUrl = "https://s.1688.com/erpoffer/offer_search.html?keywords=&charset=utf8&erp_app_key=8076003";
        if (types == "factory")
            openUrl = "https://s.1688.com/company/pc/erp_search.htm?keywords=&charset=utf8&erp_app_key=8076003";

        this.setState({
            findValue: types,
            openUrl: openUrl
        });

    }
    queryButton = () => {
        var values = $("#zhukeOfferSearchInputId").val();

        var findValue = this.state.findValue;
        var openUrl = "https://s.1688.com/erpoffer/offer_search.html?keywords=" + values + "&charset=utf8&erp_app_key=8076003";
        if (findValue == "factory")
            openUrl = "https://s.1688.com/company/pc/erp_search.htm?keywords=" + values + "&charset=utf8&erp_app_key=8076003";

        this.setState({
            openUrl: openUrl
        });
    }
    loadShopList() {
        var that = this;
        //开启动画
        requests({
            url: "/MyShop/List",
            data: {},
            success: function (res) {
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                    var listData = res.Data.DataList.Shops;

                    that.setState({
                        shopList: listData
                    },()=>{
                        //that.resetData();
                    })
                    
                } else {
                    messageShow("获取店铺列表错误：" + res.Message,'error');
                }
            },
        });
    }

    //精选货源列表
    loadList = () => {
        
    }
    batchPuHuo = () => {

        //var shopList = this.state.shopList;
        // if (shopList.length == 0) {
        //     this.addShop();
        //     return;
        // }

        //是否绑定货源账号，没有提示需要绑定
        const hasTaoteSupplierProduct = !systemConfig.zhukeTaoteAuth &&  this.state.supplierProductList.findIndex(x => x.checked && x.SourcePlatform == 'TaoteZhuKe') != -1;
        const hasAliSupplierProduct = !systemConfig.zhukeAlibabaAuth && this.state.supplierProductList.findIndex(x => x.checked && x.SourcePlatform == 'AlibabaZhuKe') != -1;
        if(hasTaoteSupplierProduct && hasAliSupplierProduct){
            this.sourcePlatformAuthDailog();
            return;
        }
        else if(hasAliSupplierProduct){
            this.sourcePlatformAuthDailog('AlibabaZhuKe');
            return;
        }
        else if(hasTaoteSupplierProduct){
            this.sourcePlatformAuthDailog('TaoteZhuKe');
            return;
        }

        var productList = this.state.supplierProductList;
        var selecrNumber = 0;
        var offerIdList = [];
        for (let i = 0; i < productList.length; i++) {
            if (productList[i].checked) {
                selecrNumber++;
                offerIdList.push(productList[i]);
            }
        }

        if (selecrNumber == 0) {
            messageShow("请选择货源",'info');
            return;
        }

        //this.resetData();//重置选择

        this.setState({
            listingProductList: offerIdList,
            isShowPuHuo: true,
        },()=>{
            //this.distributionPreposition();
        })

    }

    selectCheck = (item, checked) => {
        item.checked = !checked;

        var productList = this.state.supplierProductList;
        var selectNumber = 0;
        var isAllChange=true;
        for (let i = 0; i < productList.length; i++) {
            if (productList[i].checked)
                selectNumber++;
            else
               isAllChange=false;
        }

        $("#allCheck_id_Below").prop("checked", isAllChange);//下面的按钮点击，上面的全选跟着变化

        this.setState({
            selectProductNumber: selectNumber
        })

    }

    //单个铺货
    onePuHuo = (item, productId) => {
        //this.resetData();//重置选择
        //是否绑定货源账号，没有提示需要绑定
        const hasTaoteSupplierProduct = !systemConfig.zhukeTaoteAuth && item.SourcePlatform == 'TaoteZhuKe';
        const hasAliSupplierProduct = !systemConfig.zhukeAlibabaAuth && item.SourcePlatform == 'AlibabaZhuKe';
        if(hasAliSupplierProduct){
            this.sourcePlatformAuthDailog('AlibabaZhuKe');
            return;
        }
        else if(hasTaoteSupplierProduct){
            this.sourcePlatformAuthDailog('TaoteZhuKe');
            return;
        }
        this.setState({
            listingProductList: [item],
            isShowPuHuo: true
        },()=>{
            //this.distributionPreposition();
        })
    }

    addShopButton = (shows) => {
        shows.hide();

        $("#myShopListIndexId").click();

    }


    //标签选择
    changeTag = (e, id, isChecked) => {
        var tagList = this.state.tagList;
        tagList.forEach(t => {
            if (id == t.RuleId) {
                t.checked = !isChecked;
            } else if (!isChecked)
                t.checked = false;
        })
        this.setState({
            tagList: tagList,
            current: 1,
            selectProductNumber: 0
        }, () => {
            this.loadList()
        })
    }

    //选择的排序
    orderbyChange = (e, orderby) => {
        let sortNav = this.state.sortNav;
        var sort="0";
        sortNav.forEach((item, index) => {
            // let isSelect = item.IsSelect;          
            if (item.Title == orderby) {
                item.childSort=!item.childSort
                item.IsSelect = true;

                if(item.childSort==true)
                   sort="0";
                else
                   sort="1";

            }else{
                item.IsSelect = false;
            }
        })
        this.setState({ orderby: orderby,sort:sort, sortNav },()=>{
            this.loadList();
        });
    }


    //改变页码
    changePageCurrent(current) {
        this.setState({ current: current, selectProductNumber: 0 }, () => {
            this.loadList()
        })

    }

    //改变 一页多少条
    changePageSize(pagesize) {
        this.setState({ pagesize: pagesize, current: 1 }, () => {
            this.loadList()
        })
    }

    //选择店铺
    shopChange = (Id) => {
        var check = $("#checkboxShop_" + Id).prop("checked");

        var shopList = this.state.shopList;
        for (var i = 0; i < shopList.length; i++) {
            if (shopList[i].Id == Id) {
                if (check == true && (isNotNull(shopList[i].PayUrl) || isNotNull(shopList[i].AuthUrl))) {
                    $("#checkboxShop_" + Id).prop("checked", false);//上面的按钮点击
                    messageShow( "店铺授权失效，不能勾选！",'info');
                } else
                    shopList[i].IsChecked = !shopList[i].IsChecked;
                break;
            }
        }
        this.setState({
            shopList
        })
    }


    //开始铺货,铺货前的类目匹配
    distributionPreposition = () => {
        var selectShopList = [];
        var selectShopListBySupplier = [];
        var shoplist = this.state.shopList;
        for (let i = 0; i < shoplist.length; i++) {
            if (shoplist[i].IsChecked == true) {
                selectShopList.push(shoplist[i].Id);

                selectShopListBySupplier.push({
                    ShopId: shoplist[i].Id,
                    ShopName: shoplist[i].ShopName,
                    PlatformType: shoplist[i].PlatformType,
                    CategoryNameShowText: "",
                    TargetCates: [],
                    IsLoadIng: true,
                    IsButtonRed: false,
                });
            }
        }

        if (selectShopList == null || selectShopList == undefined || (selectShopList != null && selectShopList.length == 0)) 
        {
            messageShow("请选择店铺！",'info');
            return;
        }

        var supplierProductList = [];
        var offerIdList = this.state.listingProductList;
        for (let i = 0; i < offerIdList.length; i++) {
            supplierProductList.push({
                SupplierLoginId: '',
                SupplierProductId: offerIdList[i].ProductId,
                SupplierMemberId: '',
                SourcePlatform:offerIdList[i].SourcePlatform
            })
        }

        if (supplierProductList.length == 0) {
            messageShow("请选择商品！",'info');
            return;
        }

        var data = {
            TargetShopIds: selectShopList,
            SupplierProductList: supplierProductList,
            UniqueKey: "",
        }


        this.setState({ isLoading: true, isShowChooseShopModul: false, loadingTitle: '获取商品中...', affirmByeBatchDistributionByData: data })

        var that = this;
        requests({
            url: "/BatchDistribution/VerificationCategoryv2",
            data: data,
            success: function (res) {
                //关闭动画
                that.setState({ isLoading: false });
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;


                if (res.Success) {
                    var listSupplierProduct = res.Data.SupplierProducts;
                    if (listSupplierProduct == null || listSupplierProduct == undefined)
                        listSupplierProduct = [];

                    for (let i = 0; i < listSupplierProduct.length; i++) {
                        listSupplierProduct[i].ShopDataList = selectShopListBySupplier;
                    }

                    var state = {};
                    var faildList = [];
                    var successList = [];
                    
                    supplierProductList.forEach(s => {
                        var index = listSupplierProduct.findIndex(m => m.ProductId == s.SupplierProductId);
                        if (index == -1) {
                            faildList.push(s);
                        } else {
                            successList.push(s)
                        }
                    })

                    if(successList.length==0)
                    {
                        messageShow("当前选择的货源，获取不到商品！", 'error');
                        return;
                    }

                    if(successList.length>0 && faildList.length >0)
                        messageShow("有"+faildList.length+"个商品获取不到，已过滤显示！", 'warning');
                    

                    state.supplierProductListByBatch = listSupplierProduct;
                    state.isShowByDistributionSelectCategory = true;
                    state.isShowPuHuo = false;

                    that.setState(state, () => {
                        that.getCategoryBySupplierOne();
                    })



                } else {
                    if (res.ErrorCode == "SHOP_EXPIRED") {
                        messageShow("选择的店铺包含授权过期，请选择重新店铺！", 'error');
                    }
                    else if (res.ErrorCode == "ReachListingCount") {
                        MessageBox.confirm(<div>
                            <div>
                                根据1688货源分销规则，使用1688免费版【铺货代发】
                                授权货源最多只能铺货5次。订购1688【<a className='defColor' href='https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404' target={'_blank'}>铺货代发</a>】高级版授权，不限铺货次数。
                            </div>
                            <div style={{ "marginTop": "16px" }}>
                                特别说明:免费版、高级版指1688货源端【铺货代发】
                            </div>
                        </div>, '提示', {
                            customClass: 'home_reach_listing_count_dailog',
                            confirmButtonText: "订购高级版"
                        }).then(() => {
                            window.open('https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404');
                        });
                        //that.loadUpgradeAppPayInfo();
                    }else if(res.ErrorCode="COMMON_ERROR")
                    {
                          messageShow(res.Message, 'error');
                          return;
                    }                     
                    else if (res.ErrorCode == "NOT_FREIGHT_TEMPLATE") {
                        that.setState({
                            isShowNotFreightTemplate: true,
                            notFreightTemplateValue: res.Message
                        });
                    } else {
                       if(res.Message.indexOf("商品信息获取失败") !=-1)
                         messageShow("商品信息查询不到", 'warning');

                       else
                        messageShow("铺货前匹配类目失败:" + res.Message, 'error');
                        //}
                    }
                }

            },
        });
    }

    //铺货超过5次，弹窗升级
    loadUpgradeAppPayInfo() {
        var that = this;
        requests({
            url: "/Common/LoadUpgradeAppPayInfo",
            data: { SystemVersions: 'pc' },
            success: function (res) {
                debugger;
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                    try {
                        var versionsDistinction = [];
                        var functionDistinction = [];
                        var payUserList = [];
                        var upgradeUrl = "";
                        var lingQuUpgradeUrl = "";
                        if (res.Data.VersionsDistinction != "")
                            versionsDistinction = JSON.parse(res.Data.VersionsDistinction);
                        if (res.Data.FunctionDistinction != "")
                            functionDistinction = JSON.parse(res.Data.FunctionDistinction);

                        if (res.Data.PayList != null)
                            payUserList = res.Data.PayList;

                        if (res.Data.UpgradeDistinctionByUrl != "") {
                            var UpgradeDistinctionByUrl = JSON.parse(res.Data.UpgradeDistinctionByUrl);
                            upgradeUrl = UpgradeDistinctionByUrl.UpgradeUrl;
                            lingQuUpgradeUrl = UpgradeDistinctionByUrl.LingQuUpgradeUrl;
                        }

                        var PayInfoList = versionsDistinction[that.state.PayIndex].PayInfoList ? versionsDistinction[that.state.PayIndex].PayInfoList : [];
                        that.setState({
                            versionsDistinction: versionsDistinction,
                            functionDistinction: functionDistinction,
                            payUserList: payUserList,
                            upgradeUrl: upgradeUrl,//升级链接
                            lingQuUpgradeUrl: lingQuUpgradeUrl,// 领劵升级
                            isShowReachListingCount: true,
                            PayInfoList
                        }, () => {
                            that.xufeiShopsShow();
                        });

                        // console.log("versionsDistinction", versionsDistinction)
                        // console.log("functionDistinction", functionDistinction)

                    } catch (e) {

                    }

                } else {

                }
            },
        });
    }

    xufeiShopsShow = () => {
        var xufeiShops = this.state.payUserList;
        var html = '';
        for (var i = 0; i < xufeiShops.length; i++) {
            html += '<li className="xufeiItems-item">';
            html += '<div className="xufeiItems-item-left">';
            html += '<span className="xufeiItems-item-icon"></span>';
            html += '<span className="xufeiItems-item-name">' + xufeiShops[i] + '</span>';
            html += '</div>';
            html += '<a className="xufeiItems-item-right" href="' + this.state.lingQuUpgradeUrl + '" target="_blank">领券升级</a>';
            html += '</li>';
        }
        $("#xufeiItems").html(html);
        //无缝滚动效果实现
        var oDiv = document.getElementById("xufeiContent");
        var oUl = document.getElementById("xufeiItems");
        oUl.innerHTML = oUl.innerHTML + oUl.innerHTML;
        var timer = setInterval(ulMove, 20);
        oDiv.onmouseover = function () {
            clearInterval(timer);
        }
        oDiv.onmouseout = function () {
            timer = setInterval(ulMove, 20);
        }
        function ulMove() {
            var oldP = (oUl.offsetHeight - 1) / 2;
            var newP = parseFloat(getComputedStyle(oUl).top) - 0.7;
            oUl.style.top = newP <= -oldP ? 0 : newP + "px";
        }
    }
    changeNav = (name) => {
        this.props.history.replace(name)
    }
    //精选货源搜索
    searchProduct = () => {
        this.setState({ current: 1, selectProductNumber: 0 }, () => {
            this.loadList()
        })
    }
    //========================================铺货前，匹配类目 开始====================================================


    //铺货前，获取供应商商品后，开始轮训类目
    async getCategoryBySupplierOne() {
        var productList = this.state.supplierProductListByBatch;
        var lunxunList = [];
        for (let i = 0; i < productList.length; i++) {
            var shopL = productList[i].ShopDataList;
            var shopIdL = [];
            for (let j = 0; j < shopL.length; j++) {
                shopIdL.push(shopL[j].ShopId);
            }

            lunxunList.push({
                TargetShopIds: shopIdL,
                SourceProductId: productList[i].ProductId,
                SourceCateId: productList[i].CategoryId,
                SourceCateName: productList[i].CategoryName,
                SourcePlatform: productList[i].PlatformType,
                ProductTitle: productList[i].Subject,
                UseCustom: true,
            })
        }

        //任务发出去，按商品的维度
        for (var i = lunxunList.length - 1; i >= 0; i--) {
            await this.lunxunByShopCategory(lunxunList[i]);
        }
    }

    //按商品的维度，把每个任务分发出去
    lunxunByShopCategory = (dates) => {
        var data = dates;
        var that = this;
        return new Promise((resolve, reject) => {
            requests({
                url: "/BatchDistribution/GetMatchingCategory",
                data: data,
                success: function (res) {
                    if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    {
                        that.lunxunDataResult(dates, []);
                        resolve(0);
                        return;
                    }

                    if (res.Success) {
                        //成功后，把类目的赋值上
                        var resList = res.Data.MatchingShops;
                        if (resList == null || resList == undefined)
                            resList = [];

                        //console.log("resList:" + JSON.stringify(resList));
                        that.lunxunDataResult(dates, resList);
                        resolve(1);
                    } else {
                        that.lunxunDataResult(dates, []);
                        reject(res.Message)
                    }
                },
            });
        })
    }

    lunxunDataResult = (dates, resList) => {
        var productList = this.state.supplierProductListByBatch;
        for (let i = 0; i < productList.length; i++) {
            if (dates.SourceProductId == productList[i].ProductId) {
                var shopL = JSON.parse(JSON.stringify(productList[i].ShopDataList));
                for (let j = 0; j < shopL.length; j++) {
                    var targetCatesList = [];
                    for (let k = 0; k < resList.length; k++) {
                        if (resList[k].TargetShopId == shopL[j].ShopId) {
                            if (resList[k].TargetCates == null || resList[k].TargetCates == undefined)
                                targetCatesList = [];
                            else
                                targetCatesList = resList[k].TargetCates;

                            break;
                        }
                    }

                    var textValue = "";
                    if (targetCatesList.length > 0) {
                        targetCatesList.forEach((cc) => {
                            textValue += cc.Name + '—';
                        })
                    }

                    shopL[j].TargetCates = targetCatesList;
                    shopL[j].CategoryNameShowText = textValue.substr(0, textValue.length - 1);
                    shopL[j].IsLoadIng = false;
                }
                productList[i].ShopDataList = shopL;
                break;
            }
            //productList[i]=dates;
        }
        this.setState({ supplierProductListByBatch: productList });

    }
    //立即铺货
    affirmByeBatchDistribution = () => {
        var productList = this.state.supplierProductListByBatch;
        var isNotSelect = false;
        for (let i = 0; i < productList.length; i++) {
            var shopL = JSON.parse(JSON.stringify(productList[i].ShopDataList));
            for (let j = 0; j < shopL.length; j++) {
                if (shopL[j].TargetCates.length == 0) {
                    shopL[j].IsButtonRed = true;
                    isNotSelect = true;
                }
            }
            productList[i].ShopDataList = shopL;
        }

        if (isNotSelect) {
            this.setState({ supplierProductListByBatch: productList });
            messageShow( "请选择商品类目",'info');
            return;
        }

        var data = this.state.affirmByeBatchDistributionByData;

        data.Features = {}
        data.Features.BatchListingFeaturesList = productList.flatMap(x => x.ShopDataList.map(s => { return {
            CatePathList : s.TargetCates.map(o => { return { CateId:o.Id,CateName:o.Name  }}),
            ShopId:s.ShopId,
            SupplierProductId : x.ProductId,
            SourcePlatform : x.PlatformType
        }}))
        var allNum = data.TargetShopIds.length * this.state.affirmByeBatchDistributionByData.SupplierProductList.length; //不用data.SupplierProductList这个，是因为有uniqueKey 的时候，会置空

        //目前不按云平台，统一铺货。
        this.setState({ isLoading: true, isShowChooseShopModul: false, loadingTitle: '正在铺货中...' })

        var that = this;
        requests({
            url: "/BatchDistribution/BatchListingMobileByProductIdListV2",
            data: data,
            success: function (res) {
                //关闭动画

                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                {
                    that.setState({ isLoading: false })
                    return;
                }
                var taskCodeRes = that.state.taskCodeRes;   //:{taskCode:'',isPost:false,successNumber:0,errorNumber:0,errorList:[]}
                if (res.Success) {
                    taskCodeRes.taskCode = res.Data;
                    taskCodeRes.isPost = true;
                    taskCodeRes.allNumber = allNum;

                    that.setState({ taskCodeRes: taskCodeRes });

                    setTimeout(() => {
                        //只负责把任务赋值上。不做轮训，轮训交由检查接口那里做
                        that.sureBatchDistributionPostTaskCode();
                    }, 1000);
                } else {
                    that.setState({ isLoading: false });
                    if (res.ErrorCode == "SHOP_EXPIRED") {
                        messageShow("选择的店铺包含授权过期，请选择重新店铺！", 'error');
                    }
                    //已超过免费的铺货数量
                    if (res.ErrorCode == "ReachListingCount")
                    {
                        MessageBox.confirm(<div>
                            <div>
                                根据1688货源分销规则，使用1688免费版【铺货代发】
                                授权货源最多只能铺货5次。订购1688【<a className='defColor' href='https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404' target={'_blank'}>铺货代发</a>】高级版授权，不限铺货次数。
                            </div>
                            <div style={{ "marginTop": "16px" }}>
                                特别说明:免费版、高级版指1688货源端【铺货代发】
                            </div>
                        </div>, '提示', {
                            customClass: 'home_reach_listing_count_dailog',
                            confirmButtonText: "订购高级版"
                        }).then(() => {
                            window.open('https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404');
                        });
                    }
                    else {
                        var errResList = [];
                        errResList.push("(1)" + res.Message);

                        that.sureBatchDistributionPostRes(taskCodeRes.allNumber, errResList.length, errResList);
                    }

                }
            },
        });

    }

    //轮巡  铺货任务的处理。
    sureBatchDistributionPostTaskCode = () => {
        var taskCodeRes = this.state.taskCodeRes;

        var that = this;
        requests({
            url: "/Common/GetZhuKeReqTask",
            data: { TaskCode: taskCodeRes.taskCode },
            success: function (res) {

                //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                {
                    taskCodeRes.isPost = false;
                    taskCodeRes.taskCode = '';
                    that.setState({ isLoading: false, loadingTitle: '加载日志...', taskCodeRes: taskCodeRes })
                    return false;
                }


                if (res.Success) {
                    var dates = res.Data;
                    if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
                        that.setState({ isLoading: false });

                        if (dates.Status == "Error") {
                            var errResList = [];
                            let errMessage = dates.ErrorMsg;
                            if(!errMessage)
                            {
                                errMessage = '创建任务失败';
                            }
                            errResList.push("(3)" + errMessage);

                            that.sureBatchDistributionPostRes(0, taskCodeRes.allNumber, errResList);
                        } else {

                            var rspContentJson = JSON.parse(dates.RspContent);
                            var errorList = rspContentJson == null || (rspContentJson != null && rspContentJson.ErrorList == null) ? [] : rspContentJson.ErrorList;

                            that.sureBatchDistributionPostRes(taskCodeRes.allNumber - errorList.length, errorList.length, errorList);

                        }
                    } else {

                        setTimeout(() => {
                            that.sureBatchDistributionPostTaskCode();
                        }, 1000);
                    }
                } else {
                    var errResList = [];
                    errResList.push("(2)" + res.Message);

                    that.sureBatchDistributionPostRes(0, taskCodeRes.allNumber, errResList);

                }
            },
        });

    }

    //铺货任务 结果
    sureBatchDistributionPostRes = (successNumber, errorNumber, errorList) => {

        var taskCodeRes = this.state.taskCodeRes;

        taskCodeRes.isPost = false;

        taskCodeRes.successNumber = successNumber;
        taskCodeRes.errorNumber = errorNumber;
        taskCodeRes.errorList = errorList;
        taskCodeRes.taskCode = '';

        this.setState({ isShowTaskCodeRes: true, taskCodeRes: taskCodeRes, isShowByDistributionSelectCategory: false });


    }



    //编辑类目
    editMapping = (productId, Id, platformType) => {

        this.setState({
            selectCategoryByProductId: productId,
            selectCategoryByShopId: Id,
            selectCategoryByPlatform: platformType,
            showSelectCategoryModule: true,
        });
    }

    //组件传回
    selectCategory = (cateList, selecCatetTitle) => {
        this.setState({ showSelectCategoryModule: false });

        var textValue = "";
        if (cateList != null && cateList != undefined && cateList != null) {
            if (cateList.length > 0) {
                for (let i = 0; i < cateList.length; i++) {
                    textValue += cateList[i].Name + '—';
                }
            }
        }

        var supplierCateId = 0;
        var supplierCateName = "";
        var sourcePlatform = "";
        var supplierProductListByBatch = this.state.supplierProductListByBatch;
        for (let i = 0; i < supplierProductListByBatch.length; i++) {
            if (supplierProductListByBatch[i].ProductId == this.state.selectCategoryByProductId) {
                var shopL = JSON.parse(JSON.stringify(supplierProductListByBatch[i].ShopDataList));
                for (let j = 0; j < supplierProductListByBatch[i].ShopDataList.length; j++) {
                    if (shopL[j].ShopId == this.state.selectCategoryByShopId) {
                        shopL[j].CategoryNameShowText = textValue.substr(0, textValue.length - 1);
                        shopL[j].TargetCates = cateList;
                        shopL[j].IsButtonRed = false;
                        supplierCateId = supplierProductListByBatch[i].CategoryId;
                        supplierCateName = supplierProductListByBatch[i].CategoryName;
                        sourcePlatform = supplierProductListByBatch[i].PlatformType;
                        break;
                    }
                }
                supplierProductListByBatch[i].ShopDataList = shopL;
            }
        }

        var datas = {
            SupplierCateId: supplierCateId,
            SupplierCateName: supplierCateName,
            SourcePlatform: sourcePlatform,
            TargetShopId: this.state.selectCategoryByShopId,
            TargetPlatform: this.state.selectCategoryByPlatform,
            TargetCateItems: cateList
        }


        //先隐藏，已实现，等选择类目组件做好后可以放开
        this.setState({ isLoading: true, loadingTitle: '保存类目...' })
        var that = this;
        requests({
            url: "/CateMapping/SaveCateMapping",
            data: datas,
            success: function (res) {
                that.setState({ isLoading: false })
                //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return false;

                if (res.Success) {
                    messageShow("保存类目成功",'success');
                    that.setState({ supplierProductListByBatch: supplierProductListByBatch });
                    //that.conductIdenticalCate(datas);
                } else
                    messageShow(res.Message,'error');

            },
        });
    }


    //重置数据
    resetData = () => {

        //重置店铺选择
        var shopList = this.state.shopList;
        for (let i = 0; i < shopList.length; i++) {
            shopList[i].IsChecked = false;
        }



        this.setState({ shopList: shopList });
    }


    gotoDistributionSet = () => {
        this.props.history.push('/distributionSet');
    }

    //铺货结果，跳转
    puhuoGotoLink = (id) => {
        this.setState({ isShowTaskCodeRes: false });
        $("#" + id).click();
    }



    //公共关闭
    cancelModul = (typeName) => {
        this.setState({
            [typeName]: false
        })
    }

    showFiltbarMoreOperate = () => {
        let isShowFiltbarMoreOperate = this.state.isShowFiltbarMoreOperate;
        this.setState({ isShowFiltbarMoreOperate: !isShowFiltbarMoreOperate })
    }
    // huoyuanLink = (item) => {
    //     var url = "https://detail.1688.com/offer/" + item.ProductId + ".html";

    //     if(item.SourcePlatform == 'TaoteZhuKe')
    //     {
    //         var url ='https://market.m.taobao.com/app/nozomi/app-h5-detail/main/index.html?id='+item.ProductId
    //     }
    //     window.open(url, "_blank");
    // }

    serviceEndTimeHtml = (serviceEndTime, payurl, authurl) => {
        if (!serviceEndTime)
            return null;
        if (payurl != "")//授权到期
            return;
        if (payurl == "" && authurl != "")
            return;

        const expire = parseInt(this.getTimespanDay(serviceEndTime));
        if (expire >= 7)
            return <span style={{ "color": "#aaa", "margin-top": "5px" }}>授权剩余时间: {expire}天</span>
        else if (expire < 1)
            return <span className='newerrorColor' style={{ "color": "#fe6f4f" }}>授权剩余时间不足一天</span>
        else if (expire < 7)
            return <span className='newerrorColor' style={{ "color": "#f29a1a" }}>授权剩余时间: {expire}天</span>
        return null;
    }

    //铺货设置 --跳转
    distributionSet = (shopid) => {
        var obj = {};
        obj.shopid = shopid;
        var path = {
            pathname: "distributionSet",
            state: obj
        }
        this.props.history.push(path);

        this.setState({isShowPuHuo:false});
    }


    //添加弹框
    addShop = () => {
        var userFreeAndExceedLimit = $("#userFreeAndExceedLimit").html();
        if (userFreeAndExceedLimit == "true")
            this.setState({ isShowAddShopByUpgradeApp: true });
        else {
            this.setState({
                isShowChoosePlatform: true,
                selectPlatform: 'TouTiao',
            })
        }

    };

    //去订购和去授权，都合并到和添加店铺一样。
    authAndPay = (platform) => {
        this.setState({
            selectPlatform: platform,
            isShowAddShop: true,
        })
    }
    closeAddShopModal = () => {
        this.setState({
            isShowAddShop: false
        })
    }

     //返回软件内确认授权结果
     sureAuthShop = () => {
        let that = this;
        setTimeout(function () {
            that.setState({
                isShowAuthShop: true
            })
        }, 3000)
    }

    //授权点击后，弹窗提示的操作
    successAuthShop = () => {
        var that = this;
        that.setState({
            isLoading: true,//关闭加载
            isShowAuthShop: false,//关闭授权弹窗
            hasLoadBorder: true
        });
        requests({
            url: "/MyShop/AuthNewShop",
            data: {},
            success: function (res) {
                that.setState({ isLoading: false, hasLoadBorder: false }); //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                    var shopid = res.Data.ShopId;
                    if (shopid != 0 && shopid != "") {
                        messageShow("授权成功", 'success');


                        setTimeout(() => {
                            //that.loadShopList();
                        }, 1500);
                    }
                    else
                    messageShow("未授权成功", 'info');

                } else
                    messageShow('error', "错误：" + res.Message, 'error');
            },
        });
    }

    //由子组件传回
    changeShops = (platforms, selectPlatform) => {
        this.setState({
            platforms: platforms,
            selectPlatform: selectPlatform
        });

    }
     //获取时间间隔(以天为单位)
    getTimespanDay = (date)=>
    {
        var diff = Date.parse(date) - new Date();
        return diff / (1000*60*60*24);
    }
    //选择平台确定的弹窗确认按钮
    sureChoosePlatform = () => {
        //console.log("selectPlatform",this.state.selectPlatform)
        this.setState({
            isShowChoosePlatform: false,
            isShowAddShop: true
        })
    }

    //全部，选择商品事件
    allCheckbox(types) {
        var productList = this.state.supplierProductList;
        var selectNumber = 0;
        var isCheck = false;

        if (types == "above")
          isCheck = $("#allCheck_id_Above").prop("checked");//上面的按钮
        else
          isCheck = $("#allCheck_id_Below").prop("checked");//下面的按钮

        for (let i = 0; i < productList.length; i++) {
            productList[i].checked = isCheck;

            if (productList[i].checked)
                selectNumber++;
        }

        this.setState({
            selectProductNumber: selectNumber
        })
  
    }


    //关联已有店铺商品
    relevanceShopProduct = () => {
        var obj = {};
        obj.offerId = this.state.supplierProductList[0].ProductId
        var path = {
            pathname: "shopProduct",
            state: obj
        }
        this.props.history.push(path);
    }
    
    //选择图片
    selectImage(file,that){
        const isAllowType = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
        const isLt3K = file.size / 1024 < 300;

        if (!isAllowType) {
            that.refs.selectImageRef.clearFiles();
            messageShow( "图片只能是 JPG 格式 或者 PNG 格式!",'info');
        }
        // if (!isLt3K) {
        //     that.refs.selectImageRef.clearFiles();
        //     messageShow( "图片大小不能超过300kb！",'info');
        // }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload =(e)=>{
            that.setState({ imageUrl:e.target.result});
            this.translateImgToBase64(e.target.result,1.1,(base64)=>{
                that.imageSearchProduct(base64);
            },(e)=>{
                messageShow("图片地址无效","info");
            })
            
        }
        that.refs.selectImageRef.clearFiles();
        return false;
    }

    //图片搜索
    async imageSearchProduct(img)
    {
        // if(this.state.isShowWarn){
        //     Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
        //     return;
        // }

        const data = {
            SourcePlatform:this.state.selectSourcePlatform,
            Images:[img],
        }
        this.state.needBindBuyerShop = null;
        this.setState({ isLoading:true});
        const res = await ImageSearchProductRequest(data);

        this.setState({ isLoading:false});
        if(res.Success == true)
        {
            this.state.supplierProductList = res.Data || [];
            this.state.supplierProductList.forEach(x => {
                x.PicImageUrl = x.PicImageUrl || '';
                x.PicImageUrl = x.PicImageUrl.replace(/g.search\d*.alicdn.com/,'gw.alicdn.com');
            });
            this.state.selectProductNumber = 0;
            $("#allCheck_id_Below").prop("checked", false)
            this.setState({})
        }
        if(res.ErrorCode == 'TAOTE_AUTH_INVALID' || res.ErrorCode == 'ALIBABA_AUTH_EXPIRED'){
            this.state.needBindBuyerShop = res.ErrorCode;
            this.setState({})
            return;
        }
    }
    //图片链接搜索
    searchImageLinkClick(url)
    {
        var url = $("#imageLink_input").val();
        if(!url)
        {
            messageShow("请输入图片链接","info");
            return
        }
        if(!url.match(/[a-zA-z]+:\/\/[^\s]/)){
            messageShow("请输入正确图片地址","info");
            return
        }
        this.translateImgToBase64(url,1.1,(base64)=>{
            this.state.imageUrl = base64;
            this.state.selectProductNumber = 0;
            this.state.supplierProductList = []
            this.imageSearchProduct(base64);
            this.setState({})
        },(e)=>{
            messageShow("图片地址无效","info");
        })
    }
    checkSourcePlatformAuthDailog() {
        if (!systemConfig.zhukeAlibabaAuth) {
            this.sourcePlatformAuthDailog('AlibabaZhuKe');
            return false;
        }
        return true;
    }


    /**淘特授权过期跳转对话框 */
    sourcePlatformAuthDailog = async (sourcePlatform)=>{
        
        let str = '1688和淘特'
        let fromaction;
        if(sourcePlatform == 'AlibabaZhuKe'){
            str = '1688'
            fromaction = 'alibaba_auth_expire'
        }else if(sourcePlatform == 'TaoteZhuKe'){
            str = '淘特'
            fromaction = 'taote_auth_expire'
        }
        const action = await MessageBox.msgbox({
            title: '授权提示',
            message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>{str}货源授权</span>，您未获得{str}授权或者授权失效，请先进行授权</span>,
            type: 'info',
            showCancelButton: false,
            confirmButtonText: '去授权'
        })
        if (action == 'confirm') {
            const path = { pathname: '/myAuth', state: { from_action: fromaction } }
            this.props.history.push(path);
        }
    }
    
    toMyAuthPage(errorCode){
        let fromaction;
        if(errorCode == 'ALIBABA_AUTH_EXPIRED')
        {
            fromaction = 'alibaba_auth_expire'
        }
        else if(errorCode == 'TAOTE_AUTH_INVALID')
        {
            fromaction = 'taote_auth_expire'
        }
        const path = { pathname: '/myAuth', state: { from_action: fromaction } }
        this.props.history.push(path);
    }
    /**图片压缩转换 */
    translateImgToBase64(url,rate,callback,err){
        var that = this;
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        var img = new Image  //通过构造函数绘制图片实例
        img.crossOrigin = 'Anonymous'  //处理图片跨域问题
        img.onload = function(){   //该加载过程为异步事件，请先确保获取完整图片
            var targetWidth = img.width / rate;
            var targetHeight = img.height / rate;

            canvas.width = targetWidth;
            canvas.height = targetHeight;
            context.drawImage(img, 0, 0, img.width, img.height, 0, 0, targetWidth, targetHeight)
            var URLData = canvas.toDataURL('image/jpeg');
            var size = that.showSize(URLData);
            if(size > 300){
                that.translateImgToBase64(URLData,rate,callback,err);
                return;
            }
            callback(URLData);
            canvas = null
        }
        if(err) img.onerror = err;
        img.src = url
    }
    showSize(base64url) {
        //把头部去掉
        var str = base64url.replace('data:image/png;base64,', '');
        // 找到等号，把等号也去掉
        var equalIndex = str.indexOf('=');
        if(str.indexOf('=')>0) {
            str=str.substring(0, equalIndex);
        }
        // 原来的字符流大小，单位为字节
        var strLength=str.length;
        // 计算后得到的文件流大小，单位为字节
        var fileLength=parseInt(strLength-(strLength/8)*2);
        // 由字节转换为kb
        var size = "";
        size = (fileLength / 1024).toFixed(2);
        var sizeStr = size + ""; //转成字符串
        var index = sizeStr.indexOf("."); //获取小数点处的索引
        var dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
        if (dou == "00") { //判断后两位是否为00，如果是则删除00                
          return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
        }
        return size;
    }
    clearImgage(e){
        this.state.imageUrl = "";
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.setState({});
    }
    tableNavChange = (item)=>
    {
        this.state.selectSourcePlatform = item.value;
        if(this.state.imageUrl)
        {
            this.translateImgToBase64(this.state.imageUrl,1.1,(base64)=>{
                this.state.selectProductNumber = 0;
                this.state.supplierProductList = []
                this.imageSearchProduct(base64);
                this.setState({})
            })
        }
    }

    showPreviewDistributionList= async ()=>{
        //是否绑定货源账号，没有提示需要绑定
        const hasTaoteSupplierProduct = !systemConfig.zhukeTaoteAuth &&  this.state.supplierProductList.findIndex(x => x.checked && x.SourcePlatform == 'TaoteZhuKe') != -1;
        const hasAliSupplierProduct = !systemConfig.zhukeAlibabaAuth && this.state.supplierProductList.findIndex(x => x.checked && x.SourcePlatform == 'AlibabaZhuKe') != -1;
        if(hasTaoteSupplierProduct && hasAliSupplierProduct){
            this.sourcePlatformAuthDailog();
            return;
        }
        else if(hasAliSupplierProduct){
            this.sourcePlatformAuthDailog('AlibabaZhuKe');
            return;
        }
        else if(hasTaoteSupplierProduct){
            this.sourcePlatformAuthDailog('TaoteZhuKe');
            return;
        }

        var productList = this.state.supplierProductList;
        var selecrNumber = 0;
        var offerIdList = [];
        for (let i = 0; i < productList.length; i++) {
            if (productList[i].checked) {
                selecrNumber++;
                offerIdList.push(productList[i]);
            }
        }
        if(offerIdList.length == 0){
            messageShow('请选择商品！','info');
            return
        }
        if(offerIdList.length > 10){
            messageShow('最多选择十个预览铺货','info');
            return
        }
        

        this.setState({
            selectPreviewProductList:offerIdList,
            showPreviewDistributionDailog: true,
        })

    }
    previewSureBatchPuhuo= async(listingProducts)=>{
        this.state.showPreviewDistributionDailog = false
        console.log('listingProducts =>',listingProducts)
        let supplierProductList = listingProducts.map(x => { return { 
            SupplierProductId : x.supplierProduct.ProductId,
            SourcePlatform : x.supplierProduct.PlatformType
        }})
        const data = {
            TargetShopIds:[getLoginShopInfo().loginShopId],
            SupplierProductList:supplierProductList,
            ProductTag :'',
            Features : {}
        }
        data.Features.BatchListingFeaturesList = listingProducts.map(x => {
            return {
                CatePathList : x.catePathList,
                RelationCode : x.RelationCode,
                Title : x.supplierProduct.Subject,
                ShopId:getLoginShopInfo().loginShopId,
                SupplierProductId : x.supplierProduct.ProductId,
                SourcePlatform : x.supplierProduct.PlatformType
            }
        })
        if (this.state.selectPlatformNav == 'jxhy')
            data.ProductTag = 'pifatuan';
        var allNum = listingProducts.length; //不用data.SupplierProductList这个，是因为有uniqueKey 的时候，会置空

        //目前不按云平台，统一铺货。
        this.setState({ isLoading: true, isShowChooseShopModul: false, loadingTitle: '正在铺货中...' })
        const res = await BatchListingMobileByProductIdListV2Request(data)
        const taskCodeRes = this.state.taskCodeRes;   //:{taskCode:'',isPost:false,successNumber:0,errorNumber:0,errorList:[]}
        if (res.Success) {
            taskCodeRes.taskCode = res.Data;
            taskCodeRes.isPost = true;
            taskCodeRes.allNumber = allNum;

            this.setState({ taskCodeRes: taskCodeRes });

            setTimeout(() => {
                //只负责把任务赋值上。不做轮训，轮训交由检查接口那里做
                this.sureBatchDistributionPostTaskCode();
            }, 1000);
        } else {
            this.setState({ isLoading: false })

            //已超过免费的铺货数量
            if (res.ErrorCode == "ReachListingCount")
            {
                MessageBox.confirm(<div>
                    <div>
                        根据1688货源分销规则，使用1688免费版【铺货代发】
                        授权货源最多只能铺货5次。订购1688【<a className='defColor' href='https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404' target={'_blank'}>铺货代发</a>】高级版授权，不限铺货次数。
                    </div>
                    <div style={{ "marginTop": "16px" }}>
                        特别说明:免费版、高级版指1688货源端【铺货代发】
                    </div>
                </div>, '提示', {
                    customClass: 'home_reach_listing_count_dailog',
                    confirmButtonText: "订购高级版"
                }).then(() => {
                    window.open('https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404');
                });
            }
                //this.setState({ isShowReachListingCount: true });
            else {
                var errResList = [];
                errResList.push("(1)" + res.Message);
                this.sureBatchDistributionPostRes(taskCodeRes.allNumber, errResList.length, errResList);
            }
        }

    }
    cancelPreviewDistribution=()=>{
        this.setState({showPreviewDistributionDailog:false})

    }

    //========================================铺货前，匹配类目 end====================================================
    render() {
        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                   
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeNav} defaultActive={"/ImageSearchProduct"} />
                    </div>
                    <div className="wrap-right">
                    <div className='zk-maiwrap'  style={{ padding:0,marginTop:"20px"}}> 
                      <iframe className='zk-maiwrap-iframe' src='https://air.1688.com/app/channel-fe/search/index.html#/result?isv_appkey=8076003&isv_distribute_mode=message&encode_params=N4IgjgrgpgTgniAXCEAaEEYBsCK15IgDWUcA7gPYwAmAzgLxogUCW1hTALnAA5SEBpAOogAvkA'></iframe>
                    </div>   
                    <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>
                        <div className='imageSearchWrap'  style={{"display":"none"}}>
                            <div className='zk-maiwrap offterSearch-navWrap'>
                                {
                                    <div className='imageSelectWrap'>
                                        {
                                            <Upload
                                                ref={"selectImageRef"}
                                                className="avatar-uploader"
                                                showFileList={false}
                                                action={null}
                                                multiple={false}
                                                limit={1}
                                                listType="picture"
                                                beforeUpload={(file) =>{ return this.selectImage(file,this) }}
                                                onChange={(file,fileList) => { }}
                                                >
                                                {
                                                    this.state.imageUrl ? 
                                                        <div className='imageUpload'>
                                                            <span className='iconfont icon-laji' onClick={(e)=>{ this.clearImgage(e) }}
                                                                style={{ color:"#de001a","fontWeight":"600","position":"absolute","marginTop":"-60px","marginLeft":"70px","backgroundColor":"#fff","borderRadius":"5px"}}>
                                                            </span>
                                                            
                                                            <img style={{"maxWidth":"90%","maxHeight":"90%"}} src={this.state.imageUrl} className="avatar" />
                                                        </div> : 
                                                        <div className='imageUpload'>
                                                            <i className="el-icon-plus avatar-uploader-icon"></i>
                                                            <span>上传图片</span>
                                                        </div>
                                                }
                                            </Upload>
                                        }
                                        <div>
                                            <div style={{color:"rgb(170, 170, 170)"}}>以图搜款可以上传本地文件，也可以直接输入网络图片地址进行搜款</div>
                                            <div  className="imageLink">
                                                <div>图片链接：</div>
                                                <div style={{width:"700px"}}>
                                                    <Input id="imageLink_input"></Input>
                                                </div>
                                                <Button type="primary" onClick={() =>{this.searchImageLinkClick() }}>开始搜款</Button>
                                            </div>
                                            {/* <div style={{"marginTop":"8px","display":"flex","alignItems":"center"}}>
                                                <span style={{"marginRight":"20px"}}>支持平台：</span>
                                                <span style={{"display":"flex","gap":"8px"}}>
                                                    <img src="https://www.dgjapp.com/public/images/kaifang/alibaba_logo.png" alt="" width={"30px"} height={"30px"} />
                                                    <img src="https://www.dgjapp.com/public/images/kaifang/taote_logo.png" alt="" width={"30px"} height={"30px"} />
                                                </span>
                                            </div> */}
                                        </div>
                                    </div>
                                }
                            </div>

                            {
                                <div className='zk-maiwrap' style={{ marginBottom: "70px",marginLeft:0,marginRight:0,display:"block"}}>
                                    <div>
                                        {/* <div className="zk-maiwrap-all-optioin">全部</div>
                                        <div className="zk-maiwrap-all-optioin">1688</div>
                                        <div className="zk-maiwrap-all-optioin">淘特</div> */}
                                        <TableNavChange distributionStatus={this.state.tabList} noShowNum={true} changeNav={this.tableNavChange} />
                                    </div>
                                    <div>
                                        <ul className="ph-shopProductWrap">
                                            {
                                                this.state.supplierProductList.map((item, index) =>
                                                    <li className={item.checked ? "ph-shopProductWrap-item active" : "ph-shopProductWrap-item"}>
                                                        <span className="ph-shopProductWrap-item-dagou"><i className='iconfont icon-dagou'></i></span>
                                                        <div className="ph-shopProductWrap-item-up">
                                                            <div className="ph-shopProductWrap-item-up-img" style={{ backgroundImage: `url(${item.PicImageUrl})` }}></div>
                                                            <div className="ph-shopProductWrap-item-up-status" style={{top:'1px',left:'176px'}}>
                                                                {/* { item.SourcePlatform == "TaoteZhuKe"? <span style={{ background: "rgba(255,137,0,0.8)" }}>淘特货源</span>:null } */}
                                                                { item.SourcePlatform == "AlibabaZhuKe"? <img src="https://www.dgjapp.com/public/images/kaifang/alibaba_logo.png" alt="" width={"40px"} height={"40px"} />:null }
                                                                { item.SourcePlatform == "TaoteZhuKe"? <img src="https://www.dgjapp.com/public/images/kaifang/taote_logo.png" alt="" width={"40px"} height={"40px"} />:null }
                                                                
                                                            </div>
                                                        </div>

                                                        <div className="ph-shopProductWrap-item-mid">
                                                            <div onClick={() => huoyuanLink(item)} className="ph-shopProductWrap-item-mid-text" title={item.Title}>{item.Title}</div>
                                                            <div className="ph-shopProductWrap-item-mid-price">
                                                                <span style={{ color: "#ff8a00" }}>{item.Price}</span>
                                                                {/* <span style={{ color: "#ff4400" }}>{item.TejiaTotalSoldQuantity}</span> */}
                                                            </div>
                                                        </div>
                                                        <div className="ph-shopProductWrap-item-down">
                                                            <span onClick={() => this.selectCheck(item, item.checked)}>{item.checked ? <i style={{ color: "#fea032" }}>取消选中</i> : "选中"}</span>
                                                            <span onClick={() => this.onePuHuo(item, item.ProductId)}>立即铺货</span>
                                                        </div>
                                                    </li>
                                                )
                                                
                                            }

                                        </ul>
                                        {
                                            this.state.supplierProductList.length == 0 && !this.state.needBindBuyerShop?
                                            <div className="noneData-wrap">
                                                <i className="iconfont icon-wushuju"></i>
                                                <span className="noneData-title">暂无数据！</span>
                                            </div>:null
                                        }
                                        {
                                            this.state.needBindBuyerShop ?
                                            <div className="noneData-wrap">
                                                <span className="noneData-title">当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>
                                                    {this.state.needBindBuyerShop == 'TAOTE_AUTH_INVALID'  ? '淘特':'1688'}货源授权</span>，
                                                    您未获得{this.state.needBindBuyerShop == 'TAOTE_AUTH_INVALID' ? '淘特':'1688'}授权或者授权失效，请先进行授权</span>
                                                <div style={{ marginTop:'10px'}}>
                                                    <span className="el-button el-button--primary" onClick={() => this.toMyAuthPage(this.state.needBindBuyerShop) }>前往授权</span>
                                                </div>
                                            </div>:null
                                        }

                                        {/* <Paginations current={this.state.current} totals={this.state.totals} pageSize={this.state.pagesize} changePageSize={(pagesize) => { this.changePageSize(pagesize) }} changePageCurrent={(current) => this.changePageCurrent(current)} /> */}
                                        <div className='paginationwrap'>
                                            {/* <Pagination onCurrentChange={this.changePageCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.totals} pageSize={this.state.pagesize} currentPage={this.state.current} pageSizes={[10, 20, 30, 50]} /> */}
                                        </div>
                                    </div>
                                    <div className="zk-footer" style={{"zIndex":"10"}}>
                                        <span className="zk-footer-checkWrap">
                                            <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
                                            <span>已选取<i style={{ fontWeight: 700, color: "#5584ff", fontSize: "14px" }}>{this.state.selectProductNumber}</i>个货品</span>
                                        </span>
                                        <span className="el-button el-button--primary" onClick={() => this.batchPuHuo()}>批量铺货</span>
                                        <span className="el-button" onClick={() => this.showPreviewDistributionList()} style={{border:"1px solid #5584ff",color:"#5584ff",backgroundColor:"#fff"}}>预览铺货</span>
                                        
                                    </div>

                                </div> 
                            }

                            {/* 升级版本,免费版只能铺货5次 */}
                            {
                                this.state.isShowReachListingCount ?
                                    <div className="xufeiWrap">
                                        <div className="xufeiDailog">
                                            <span className='iconfont icon-shanchu' onClick={() => this.cancelModul("isShowReachListingCount")}></span>
                                            <div className="xufeiDailog-up">
                                                <div className="xufeiDailog-up-main">
                                                    <div className="xufeiDailog-up-main-icon"></div>
                                                    <div className="xufeiDailog-up-main-content">
                                                        <span>您已成功铺货<i style={{ padding: "0 5px", fontWeight: 700, fontSize: "17px", color: "#f7941f" }}>5</i>次，达到免费版工具铺货上限，升级工具，不限铺货次数</span>
                                                        <span>已铺货成功商品订单回流采购不受影响</span>
                                                    </div>
                                                </div>
                                                <div className="xufeiDailog-up-button">
                                                    <span onClick={() => this.gotoLink(this.state.upgradeUrl)}>升级工具</span>
                                                </div>
                                            </div>
                                            <div className="xufeiDailog-main">
                                                <div className="xufeiDailog-main-left">
                                                    <div className="xufeiDailog-main-left-one">
                                                        {
                                                            this.state.versionsDistinction.map((item, index) =>
                                                                index == 0 ?
                                                                    <div className="xufeiDailog-coupon">
                                                                        <div className="xufeiDailog-coupon-title">{item.VersionName}</div>
                                                                        <div className="xufeiDailog-coupon-main">
                                                                            <span>{item.VersionText1} </span>
                                                                            <span>{item.VersionText2} </span>
                                                                        </div>
                                                                        <a className="xufeiDailog-coupon-button"> {item.VersionText3}</a>
                                                                    </div> :
                                                                    <div className="xufeiDailog-coupon active" style={{ boxShadow: "0 0 21px 0px #ffdb8d" }}>
                                                                        <div className="xufeiDailog-coupon-title"><i></i>{item.VersionName}</div>
                                                                        <div className="xufeiDailog-coupon-title02"><span>高级版特权</span></div>
                                                                        <div className="xufeiDailog-coupon-main">
                                                                            <span style={{ color: "#ff4c34", fontSize: "15px", fontWeight: "700" }}> {item.VersionText1}</span>
                                                                            <span style={{ color: "#ff4c34", fontSize: "15px", fontWeight: "700" }}>{item.VersionText2}</span>
                                                                        </div>
                                                                        <a style={{ marginTop: "10px" }} className="xufeiDailog-coupon-button"> {item.VersionText3}</a>
                                                                    </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="xufeiDailog-main-left-two">
                                                        <div className="xufeiDailog-main-left-two-title">他们刚刚升级，一起升级无限量铺货</div>
                                                        <div className="xufeiContent" id="xufeiContent">
                                                            <ul className="xufeiItems" id="xufeiItems"></ul>
                                                        </div>
                                                    </div>
                                                    <div className="xufeiDailog-main-left-three">
                                                        {
                                                            this.state.PayInfoList.map((item, index) =>
                                                                <a className="coupon-item" onClick={() => this.gotoLink(item.URL)}>
                                                                    <div className="coupon-item-up">
                                                                        <span>{item.InfoText1}</span>
                                                                        <span>{item.InfoText2}</span>
                                                                        <i>券</i>
                                                                    </div>
                                                                    <div className="coupon-item-down">升级工具</div>
                                                                </a>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className="xufeiDailog-main-right">
                                                    <div className="xufeiDailog-right-main">
                                                        <ul className="xufeiDailog-table-header">
                                                            <li style={{ width: "75px", marginLeft: 0 }}>环节</li>
                                                            <li style={{ width: "165px" }}>功能名称</li>
                                                            <li style={{ width: "120px", color: "#888" }}>免费版</li>
                                                            <li style={{ width: "132px" }}><i className="iconfontCoupon"></i>高级版</li>
                                                        </ul>
                                                        <div className="xufeiDailog-table-wrap">
                                                            <table className="xufeiDailog-table">
                                                                {
                                                                    this.state.functionDistinction.map((item, index) =>
                                                                        <tbody>
                                                                            {
                                                                                item.FunctionList.map((cItem, cIndex) =>
                                                                                    cIndex == 0 ?
                                                                                        <tr>
                                                                                            <td className="td-nth1" rowspan={item.FunctionList.length} >{item.FunctionType}</td>
                                                                                            <td className="td-nth2">{cItem.Name}</td>
                                                                                            {
                                                                                                cItem.TypeFree == "true" ?
                                                                                                    <td className="td-nth3"><i className="iconfontgou">✔</i></td> :
                                                                                                    cItem.TypeFree == "false" ?
                                                                                                        <td className="td-nth3"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth3">{cItem.TypeFree}</td>
                                                                                            }
                                                                                            {
                                                                                                cItem.TypeAdvanced == "true" ?
                                                                                                    <td className="td-nth4"><i className="iconfontgou active">✔</i></td> :
                                                                                                    cItem.TypeAdvanced == "false" ?
                                                                                                        <td className="td-nth4"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth4">{cItem.TypeAdvanced}</td>
                                                                                            }
                                                                                        </tr> :
                                                                                        <tr>
                                                                                            <td className="td-nth2">{cItem.Name}</td>
                                                                                            {
                                                                                                cItem.TypeFree == "true" ?
                                                                                                    <td className="td-nth3"><i className="iconfontgou">✔</i></td> :
                                                                                                    cItem.TypeFree == "false" ?
                                                                                                        <td className="td-nth3"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth3">{cItem.TypeFree}</td>
                                                                                            }
                                                                                            {
                                                                                                cItem.TypeAdvanced == "true" ?
                                                                                                    <td className="td-nth4"><i className="iconfontgou active">✔</i></td> :
                                                                                                    cItem.TypeAdvanced == "false" ?
                                                                                                        <td className="td-nth4"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth4">{cItem.TypeAdvanced}</td>
                                                                                            }
                                                                                        </tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    )
                                                                }
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null
                            }

                        </div>
                    </div>
                  
                </main>
              
                
                    
                <ShowModal width={"600px"} showModal={this.state.isShowPuHuo} hideBtn={true} titleName="选择要铺货的店铺" >
                    {/* <div className='showPuHuo-title'>
                        <span></span>
                        <span className='showPuHuo-title-right' onClick={this.addShop}><i className='iconfont icon-jia-copy1'></i>添加店铺</span>
                    </div> */}
                    <div className="offerSearch-puhuoDailog">
                        <table className='table-style01'>
                            <tbody>
                                {
                                    this.state.shopList.length==0?
                                    <tr>
                                        <td>无店铺信息，请添加店铺！</td>
                                    </tr>:null
                                }
                                {
                                    this.state.shopList.map((item, index) =>
                                        <tr>
                                            <td>
                                                <div className='shopList-item'>
                                                    {
                                                        item.IsChecked == true ? <input type="checkbox" id={"checkboxShop_" + item.Id} onClick={() => this.shopChange(item.Id)} checked={true}/>:
                                                        <input type="checkbox" id={"checkboxShop_" + item.Id} onClick={() => this.shopChange(item.Id)} />
                                                    }
                                                    <PlatformName platformType={item.PlatformType} iconSize={"smallIcon"} isHidePatformName={true} />
                                                    <span>{item.ShopName}</span>
                                                </div>
                                            </td>
                                            <td style={{width:"250px"}}>

                                                {
                                                    this.serviceEndTimeHtml(item.ServiceEndTime, item.PayUrl, item.AuthUrl)
                                                } 
                                                {/* {
                                                    item.PayUrl != "" ?
                                                        <span className="newerrorColor">店铺授权已失效，请重新授权店铺！</span>
                                                        : null
                                                }
                                                {
                                                    item.PayUrl == "" && item.AuthUrl != "" ?
                                                        <span className="newerrorColor">店铺授权已失效，请重新授权店铺！</span>
                                                        : null
                                                } */}
                                            </td>
                                            <td>
                                             {
                                                    item.PayUrl == "" && item.AuthUrl == "" ?
                                                        <span className="norSecondBtn" onClick={() => this.distributionSet(item.Id)}>铺货设置</span>
                                                        : null
                                                }

                                                {/* {
                                                    item.PayUrl != "" ?
                                                        <span className="norSecondBtn norThirthBtn" onClick={() => this.authAndPay(item.PlatformType)}>去授权</span>
                                                        : null
                                                } */}

                                                {/* 授权按钮*/}
                                                {/* {
                                                    item.PayUrl == "" && item.AuthUrl != "" ?
                                                        <span className="norSecondBtn norThirthBtn" onClick={() => this.authAndPay(item.PlatformType)}>去授权</span>
                                                        : null
                                                } */}
                                            </td>
                                        </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        {
                            // this.state.supplierProductList.length==1?
                            // <span className="showModalWrap-box-footer-btn cancleBtn"  style={{ marginRight: "320px" }}  onClick={() => this.relevanceShopProduct()}>关联商品</span>
                            // :null
                        }
                        
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.distributionPreposition()}>开始铺货</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowPuHuo")}>取消</span>
                    </div>
                </ShowModal>



                <ShowModal width={"680px"} showModal={this.state.isShowByDistributionSelectCategory} hideBtn={true} showLeftTopBtn={true} cancelDailog={() => this.cancelModul("isShowByDistributionSelectCategory")} titleName={"确认商品类目"}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "10px" }}>
                        <div className='categoryNameWarn'>默认智能匹配类目，智能匹配未匹配上时需手动选择商品类目</div>

                        {
                            this.state.supplierProductListByBatch.map((item, index) =>
                                <div className='supplierProductWrap' style={{ "marginTop": index > 0 ? "30px" : "0" }}>
                                    <div className='supplierProductWrap-info'>
                                        <img style={{ width: '60px', height: '60px' }} src={item.PicURI == null || item.PicURI == "" ? 'https://cbu01.alicdn.com/images/cn/market/myalibaba/newmyali/nopic.gif' : item.PicURI} alt="" />
                                        <div className='supplierProductWrap-info-left'>
                                            <span>{item.Subject}</span>
                                            <span style={{ marginTop: "5px", color: "#f7941f" }}>类目：{item.CategoryName}</span>
                                        </div>

                                    </div>
                                    <div className='supplierProductWrap-table'>
                                        {
                                            item.ShopDataList.map((shop) =>
                                                <div className='supplierProductWrap-table-tr'>
                                                    <div className='supplierProductWrap-shopName'>
                                                        <PlatformName platformType={shop.PlatformType} iconSize={"smallIcon"} isHidePatformName={true} />
                                                        <span>{shop.ShopName}</span>
                                                    </div>
                                                    {
                                                        shop.IsLoadIng ?
                                                            <div className='supplierProductWrap-operate'>
                                                                <span style={{ color: "#888" }}>加载中</span>
                                                                <img style={{ width: 25, height: 25, marginRight: "3rem" }} src="https://dgjapp.com/public/images/zhipoIcon/timg02.gif" />
                                                            </div>
                                                            : <div className='supplierProductWrap-operate' onClick={() => this.editMapping(item.ProductId, shop.ShopId, shop.PlatformType)}>
                                                                {
                                                                    shop.TargetCates.length == 0 && shop.IsButtonRed == true ?
                                                                        <div className='supplierProductWrap-choseRight' style={{ color: "#fe6f4f" }}>
                                                                            <span className='supplierProductWrap-text'>请选择类目</span>
                                                                            <span className='iconfont icon-xiangxia'></span>
                                                                        </div>
                                                                        : shop.TargetCates.length == 0 && shop.IsButtonRed == false ?
                                                                            <div className='supplierProductWrap-choseRight' >
                                                                                <span className='supplierProductWrap-text' style={{ color: "#ccc" }}>请选择类目</span>
                                                                                <span className='iconfont icon-xiangxia'></span>
                                                                            </div>
                                                                            : <div className='supplierProductWrap-choseRight'>
                                                                                <span className='supplierProductWrap-text'>{shop.CategoryNameShowText}</span>
                                                                                <span className='iconfont icon-xiangxia'></span>
                                                                            </div>
                                                                }

                                                            </div>
                                                    }


                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }



                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.affirmByeBatchDistribution()}>立即铺货</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowByDistributionSelectCategory")}>取消</span>
                    </div>
                </ShowModal>


                <ShowModal showModal={this.state.showSelectCategoryModule} titleName={"选择类目"} cancelDailog={() => this.cancelModul("showSelectCategoryModule")} hideBtn={true} showLeftTopBtn={true}>
                    <SelectCategoryModule
                        showSelectCategoryModule={this.state.showSelectCategoryModule}
                        targetPlatformType={this.state.selectCategoryByPlatform}
                        targetShopId={this.state.selectCategoryByShopId}
                        selectCategory={this.selectCategory}
                    />
                </ShowModal>



                {/* 未设置运费模板 */}
                <ShowModal width={"500px"} showModal={this.state.isShowNotFreightTemplate} hideBtn={true} titleName="提示" >
                    <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "20px" }}>
                        <div>
                            <span>{this.state.notFreightTemplateValue}</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.gotoDistributionSet()}>前往设置</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowNotFreightTemplate")}>取消</span>
                    </div>
                </ShowModal>

                {/* 铺货结果 */}
                <ShowModal width={"500px"} showModal={this.state.isShowTaskCodeRes} hideBtn={true} showLeftTopBtn={true} cancelDailog={() => this.cancelModul("isShowTaskCodeRes")} >
                    <div className="showModalWrap-box-commonContent" style={{ padding: "25px" }}>
                        <div className="showModalWrap-commonContent-item" style={{ marginBottom: "25px" }}>
                            {
                                this.state.taskCodeRes.successNumber > 0 && this.state.taskCodeRes.errorNumber == 0 ?
                                    <i className="iconfont icon-dagou icofontStatus"></i> : null
                            }
                            {
                                this.state.taskCodeRes.successNumber > 0 && this.state.taskCodeRes.errorNumber > 0 ?
                                    <i className="iconfont icon-gantan icofontStatus"></i> : null
                            }
                            {
                                this.state.taskCodeRes.successNumber == 0 && this.state.taskCodeRes.errorNumber > 0 ?
                                    <i className="iconfont icon-add-fill-hover-copy icofontStatus"></i> : null
                            }

                            <span style={{ fontSize: "16px" }}>铺货任务已提交，成功：<i style={{ color: "#5584FF" }}>{this.state.taskCodeRes.successNumber}</i>，失败：<i style={{ color: "#fe6f4f" }}>{this.state.taskCodeRes.errorNumber}</i></span>
                            {
                                this.state.taskCodeRes.errorNumber != 0 ? <text>失败详情如下：</text> : null
                            }
                        </div>
                        <div style={{ padding: "20px", fontSize: "16px" }}>可在<text style={{ color: "red" }}>铺货日志</text>中查看铺货结果</div>
                        {
                            this.state.taskCodeRes.errorList.length > 0 ?
                                <div>
                                    {
                                        this.state.taskCodeRes.errorList.map((item) =>
                                            <text key={item}>{item}</text>
                                        )
                                    }
                                </div>
                                : null
                        }

                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.props.history.push('/distributionLog')}>铺货日志</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.props.history.push('/')}>进入首页</span>

                    </div>
                </ShowModal>


                 {/* 添加店铺步骤弹窗*/}
                 {/* <ShowModal titleName={"添加" + this.state.selectPlatformName + "店铺"} width={"680px"} showModal={this.state.isShowAddShop} hideBtn={true}>
                    <div>
                        <DialogAddShopSteps sureAuthShop={this.sureAuthShop} selectPlatformName={selectPlatformName} selectPlatform={this.state.selectPlatform} showContact={this.showContact} />
                        <div className="showModalWrap-box-commonfooter">
                            <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeAddShopModal()}>关闭</span>
                        </div>
                    </div>
                </ShowModal> */}
                <ShowModal width={"500px"} showModal={this.state.isShowAuthShop} sureDailog={this.successAuthShop} sureBtnName={"完成授权"} cancelDailog={() => this.cancelModul("isShowAuthShop")}>
                    <div style={{ padding: "20px", fontSize: "16px" }}>你是否已经完成授权？</div>
                </ShowModal>

                 {/* 免费版，店铺超过5个，不允许点击，弹窗提示 */}
                 <ShowModal hideTitle={true} width={"600px"} showModal={this.state.isShowAddShopByUpgradeApp} hideBtn={true} titleName="提示" >
                    <span className='iconfont icon-chuyidong addShopWarn-chuyi' onClick={() => this.cancelModul("isShowAddShopByUpgradeApp")}></span>
                    <div className="addShopWarn-up">
                        <i className="iconfont icon-gantan"></i>
                        <span className='addShopWarn-up-title'>免费版用户只能添加<i style={{ color: "#ffa51b", padding: "0 5px" }}>5</i>个店铺！</span>
                    </div>
                    <div className="addShopWarn-main-left-one">
                        <div className="addShopWarn-coupon">
                            <div className="addShopWarn-coupon-title">免费版</div>
                            <div className="addShopWarn-coupon-main">
                                <span>添加店铺：5个 </span>
                            </div>
                        </div>
                        <div className="addShopWarn-coupon active">
                            <div className="addShopWarn-coupon-title"><i></i>高级版</div>
                            <div className="addShopWarn-coupon-main">
                                <span style={{ color: "#ff8a00" }}> 添加店铺：50个</span>
                            </div>
                        </div>
                    </div>
                    <div className='addShopWarn-down'>
                        <span className='addShopWarn-down-span' onClick={() => this.gotoUpgradeLink()}>立即升级 添加更多店铺</span>
                    </div>
                </ShowModal>

               {/* 选择平台弹窗*/}
               {/* <ShowModal titleName={"请选择需要添加的店铺类型"} width={"660px"} showModal={this.state.isShowChoosePlatform} sureDailog={this.sureChoosePlatform} cancelDailog={() => this.cancelModul("isShowChoosePlatform")} >
                    <DialogShowPlatforms platforms={this.state.platforms} changeShops={this.changeShops} selectPlatform={this.state.selectPlatform} />
                </ShowModal> */}
                {
                    this.state.showPreviewDistributionDailog ?
                        <PreviewDistributionList 
                                            targetPlatformType={getLoginShopInfo().loginShopPlatformType}
                                            targetShopId={getLoginShopInfo().loginShopId}
                                            showModal={this.state.showPreviewDistributionDailog} 
                                            productList={this.state.selectPreviewProductList}
                                            sureBatchPuhuo={this.previewSureBatchPuhuo} //点确定铺货按钮 函数
                                            cancelDailog={this.cancelPreviewDistribution} //点关闭铺货按钮 函数
                                        />: null
                }
                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
                <NewUserGuide></NewUserGuide>
            </div>
        );
    }
}

export default AlibabaRecommendProduct;


// WEBPACK FOOTER //
// ./src/pages/alibabaRecommendProduct/alibabaRecommendProduct.jsx